// React 18 has native support for useId. This is a hook that intends to provide
// similar functionality.
import { useRef } from 'react';
import uniqueId from 'lodash/uniqueId';

export default function useUniqueId(prefix?: string | undefined) {
  const idRef = useRef(uniqueId(prefix));
  return idRef.current;
}
